import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './RecursiveAccordion.module.css'; // Подключи свой файл
import { styled } from 'tt-ui-kit';
import { max } from 'd3';

const CustomizedAccordion = styled(Accordion)(() => ({
  '.MuiAccordionDetails-root': {
    padding: 0,
    maxHeight: 'none',
  },
  '&.MuiAccordion-root': {
    borderRadius: '12px',
    padding: '16px',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.04)',
    margin: '0px 20px 20px 20px',
    maxWidth: 'none',
    overflow: 'visible',
  },
  '&:before': {
    backgroundColor: 'white',
  },
  boxShadow: 'none',
}));

const RecursiveAccordion = ({ node, expandedIds, onToggle, renderElement }) => {
  const isExpanded = expandedIds.includes(node.code);

  return (
    <CustomizedAccordion
      expanded={isExpanded}
      onChange={() => onToggle(node.code)}
      key={node.code}
      sx={{
        borderRadius: '16px',
        padding: '20px',
        margin: '0px 0px 16px 0px !important',
        '&.MuiAccordionSummary-root': {
          margin: '12px 10px !important',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${node.code}-content`}
        id={`panel-${node.code}-header`}
        sx={{
          padding: '20px 0',
          margin: '20px 20px !important',
        }}
      >
        <div className={styles.summary}>
          <div className={styles.title}>{node.name}</div>
        </div>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          marginTop: '10px',
          padding: '20px',
          overflow: 'visible !important',
        }}
      >
        {node.sub &&
          node.sub.map((child) => (
            <RecursiveAccordion
              key={child.code}
              node={child}
              expandedIds={expandedIds}
              onToggle={onToggle}
              renderElement={renderElement}
            />
          ))}
        {node.children && renderElement(node.children)}
      </AccordionDetails>
    </CustomizedAccordion>
  );
};

export default RecursiveAccordion;
